import { useApi } from "lib/apiFetcher";

export const useBundleList = () => useApi("get", "/bundles");

export const useBundleDetail = (bundleSlug: string) =>
  // @ts-ignore
  useApi("get", "/bundles/{slug}", bundleSlug);

// @ts-ignore
export const useBundleEnroll = () => useApi("post", "/bundles/{slug}/enroll");

// @ts-ignore
export const useBundleStatus = () => useApi("get", "/bundles/{slug}/status");

export const useGetBundleByTenantSlug = () =>
  // @ts-ignore
  useApi("get", "/tenants/{slug}/bundles");

export const useGetBundleByTenantSlugAndSlug = () =>
  // @ts-ignore
  useApi("get", "/tenants/{slug}/bundles/{bundle_slug}");
